import React from 'react';
import AppLayout from '../../layout/app.layout';
import ListSessions from '../../components/reports/list-sessions.component';

const ReportsSessionsView = () => {
  const pageTitle = 'Analytics / Engagement / Views by Session (Video)';

  return (
    <AppLayout pageTitle={pageTitle} showFilter>
      <ListSessions />
    </AppLayout>
  );
};

export default ReportsSessionsView;
